export const EXPRESSION_VARIABLE_NAME = {
  ACTIVE_ELEMENTS_COUNT_BY_CATEGORY: 'active_elements_count_by_category',
  BUILDING_LIFETIME: 'building_lifetime',
  HEATED_AREA: 'atemp',
  /** Product service-life override (years) for the element, ranked above the SBEF table in {@link getSBEFLifetime} */
  PRODUCT_LIFETIME: 'product_lifetime',
  /**
   * Record of property values explicitly set by the user (`hasCount`) on this element
   * or any ancestor. Keys are expression variable names (see
   * {@link formatExpressionVariableName}); nearest ancestor wins. Used e.g. by
   * {@link getSBEFLifetime} so a user-set parent lifetime outranks an IVL product
   * service-life override without treating SBEF/fallback lifetimes as user-set
   * (DEV-3549).
   */
  USER_DEFINED: 'user_defined',
} as const;
